import React from 'react';
import Layout from '@app/layouts/_layout';
import { ProductAttributes } from '@app/models/dtos/strapi';
import ImageRenderer from '@app/components/media-renderer/image-renderer';
import environments from '@app/configs/environments';
import AnchorLink from '@app/components/ui/links/anchor-link';
import Item from '@app/components/item';
import RadialGradient from '@app/components/ui/radial-gradient';
import { ILayoutProps } from '@app/models/props/home';

export interface IProductProps extends ILayoutProps {
    product: ProductAttributes;
}

function Product({ product, settings, locations, products, socialMedias }: IProductProps) {
    return (
        <Layout socialMedias={socialMedias} locations={locations} settings={settings} products={products} childClassName="flex flex-col items-center pt-[60px] md:pt-[160px]">
            <RadialGradient />
            <div className="container  flex w-full flex-col">
                <p className="P2 mb-10 w-full !text-black-1">Products</p>
                <div>
                    {product.logo && 'url' in product.logo && <ImageRenderer media={environments.STRAPI_HOST_URL + product.logo.url} className="!h-6 !w-fit max-w-[186px] !object-contain filter-none" isGrayScale={false} />}
                    <p className="h4-responsive my-6 text-black-1">{product.title}</p>
                    <p className="P2 mb-10 max-w-[412px]">{product.description}</p>
                    <AnchorLink target="_blank" href={product.url} className="large-button">
                        Visit Site
                    </AnchorLink>
                </div>
            </div>
            {product.featureImage && 'url' in product.featureImage && (
                <div className="mt-[60px] flex  w-full justify-center bg-blue-2 md:mt-[90px]">
                    <div className="min-h-[572px] py-[66px]">
                        <ImageRenderer media={environments.STRAPI_HOST_URL + product.featureImage.url} isGrayScale={false} className="max-h-[440px]  filter-none" />
                    </div>
                </div>
            )}
            <div className="container w-full">
                {product.images && !('data' in product.images) && product.images.length !== 0 && (
                    <div className="grid-flow-rows mt-6 grid w-full grid-cols-1 gap-6 md:grid-cols-2 ">
                        {product.images.map((extraImage) => {
                            return (
                                <div key={extraImage?.id} className="bg-blue-3  p-[50px]">
                                    <ImageRenderer media={environments.STRAPI_HOST_URL + extraImage?.url} isGrayScale={false} className="filter-none" />
                                </div>
                            );
                        })}
                    </div>
                )}
                {product.features && product.features.length !== 0 && (
                    <div className="mt-[80px] flex w-full flex-col md:mt-[160px]">
                        <p className="P2  !text-black-1 ">Features</p>
                        <div className="mt-[20px] grid grid-flow-row grid-cols-1 gap-[45px] sm:grid-cols-2 md:mt-[40px] lg:grid-cols-3">
                            {product.features.map((item) => (
                                <Item key={item.id} item={item} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {product.values && (
                <div className=" relative mt-[60px] flex w-full flex-col  items-center  gap-10 bg-black-1 py-[50px]  md:mt-[140px] md:min-h-[570px] md:flex-row lg:py-[110px] xl:min-h-[620px] 2xl:min-h-[719px]">
                    <div className="flex w-full  justify-center">
                        <div className="container flex h-full w-full flex-col  items-start justify-center">
                            <p className="h4-responsive max-w-[500px] !text-white 2xl:max-w-[536px]">{product.values.title}</p>
                            <p className="P1 mb-10 mt-6 max-w-[412px] !text-white-2">{product.values.description}</p>
                            <div>
                                <AnchorLink target="_blank" href={product.url} className="large-button !text-white">
                                    Visit Site
                                </AnchorLink>
                            </div>
                        </div>
                    </div>
                    {product.values.image && !('data' in product.values.image) && (
                        <div className="right-0 top-[110px] aspect-products-image h-full  w-full px-5  md:-mr-[100px] md:h-[350px] md:px-0 xl:absolute xl:h-[400px]  xl:w-fit 2xl:h-[499px] ">
                            <ImageRenderer media={`${environments.STRAPI_HOST_URL}${product.values.image.url}`} isGrayScale={false} className="rounded-[8px] !object-contain filter-none " />
                        </div>
                    )}
                </div>
            )}
        </Layout>
    );
}

export { getServerSideProductProps as getServerSideProps } from '@app/lib/serverSideProps';
export default Product;
